import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  BarChart3,
  FileText,
  Mail,
  Menu as MenuIcon,
} from "lucide-react";

type NavItem = {
  to: string;
  label: string;
  icon: typeof LayoutDashboard;
};

// 底部导航：5 个固定入口
const navItems: NavItem[] = [
  { to: "/mobile/dashboard", label: "Top", icon: LayoutDashboard },
  { to: "/mobile/analytics", label: "分析", icon: BarChart3 },
  { to: "/mobile/blog", label: "Blog", icon: FileText },
  { to: "/mobile/mail", label: "Mail", icon: Mail },
  { to: "/mobile/menu", label: "Menu", icon: MenuIcon },
];

/**
 * モバイル版固定ボトムナビゲーション
 * BottomNavItem のうち現在のルートに一致するものを active 表示
 */
export const MobileBottomNav = () => {
  return (
    <nav className="mobile-bottom-nav" aria-label="メインナビゲーション">
      {navItems.map((item) => {
        const Icon = item.icon;
        return (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `mobile-bottom-nav-item ${isActive ? "active" : ""}`
            }
          >
            <Icon size={22} strokeWidth={1.8} />
            <span>{item.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
};
